import { VatRegistrationStatusChange } from "./VatRegistrationStatusChange";
import { AddCertificateStatusChange } from "./AddCertificateStatusChange";
import { AddLocalTaxStatusChange } from "./AddLocalTaxStatusChange";
import { BackToAddCertificateStatusChange } from "./BackToAddCertificateStatusChange";
import { BackToAddLocalTaxStatusChange } from "./BackToAddLocalTaxStatusChange";
import { BackToClientStatusChange } from "./BackToClientStatusChange";
import { BackToGenerateDocsStatusChange } from "./BackToGenerateDocsStatusChange";
import { BackToTAStatusChange } from "./BackToTAStatusChange";
import { BackToTranslationStatusChange } from "./BackToTranslationStatusChange";
import { DeregisteredStatusChange } from "./DeregisteredStatusChange";
import { DeregistrationInProgressStatusChange } from "./DeregistrationInProgressStatusChange";
import { GenerateDocsStatusChange } from "./GenerateDocsStatusChange";
import { PoaRevokedStatusChange } from "./PoaRevokedStatusChange";
import { ReopenStatusChange } from "./ReopenStatusChange";
import { RevokeTranslateStatusChange } from "./RevokeTranslateStatusChange";
import { RevokingPoAStatusChange } from "./RevokingPoAStatusChange";
import { ToTAStatusChange } from "./ToTAStatusChange";
import { TranslateStatusChange } from "./TranslateStatusChange";
import { UploadDocsStatusChange } from "./UploadDocsStatusChange";
export class VatRegistrationStatusChangeFactory {
  static create($type) {
    if ($type === "V1.Companies.VatRegistrations.VatRegistrationStatusChange") {
      const result = new VatRegistrationStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.AddCertificateStatusChange") {
      const result = new AddCertificateStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.AddLocalTaxStatusChange") {
      const result = new AddLocalTaxStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToAddCertificateStatusChange") {
      const result = new BackToAddCertificateStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToAddLocalTaxStatusChange") {
      const result = new BackToAddLocalTaxStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToClientStatusChange") {
      const result = new BackToClientStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToGenerateDocsStatusChange") {
      const result = new BackToGenerateDocsStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToTAStatusChange") {
      const result = new BackToTAStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.BackToTranslationStatusChange") {
      const result = new BackToTranslationStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.DeregisteredStatusChange") {
      const result = new DeregisteredStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.DeregistrationInProgressStatusChange") {
      const result = new DeregistrationInProgressStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.GenerateDocsStatusChange") {
      const result = new GenerateDocsStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.PoaRevokedStatusChange") {
      const result = new PoaRevokedStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.ReopenStatusChange") {
      const result = new ReopenStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.RevokeTranslateStatusChange") {
      const result = new RevokeTranslateStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.RevokingPoAStatusChange") {
      const result = new RevokingPoAStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.ToTAStatusChange") {
      const result = new ToTAStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.TranslateStatusChange") {
      const result = new TranslateStatusChange();
      return result;
    }
    if ($type === "V1.Companies.VatRegistrations.UploadDocsStatusChange") {
      const result = new UploadDocsStatusChange();
      return result;
    }
    throw new Error($type + " not found");
  }
}
